import React from 'react';
import { IconProps } from '../types';
const MinecraftGlisteringMelonSlice: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="2" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(201, 73, 8, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(255, 237, 231, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(215, 126, 21, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(241, 201, 5, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(241, 201, 5, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(255, 237, 231, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(193, 60, 45, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(215, 126, 21, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(201, 73, 8, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(215, 126, 21, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(202, 113, 93, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(201, 73, 8, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(241, 201, 5, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(201, 73, 8, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(175, 22, 11, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(241, 201, 5, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(201, 73, 8, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(202, 113, 93, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(215, 126, 21, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(191, 49, 35, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(222, 174, 170, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(255, 237, 231, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(255, 237, 231, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(255, 203, 198, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(154, 116, 24, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(177, 132, 28, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(204, 151, 32, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(94, 84, 11, 255)" />
</svg>);
export default MinecraftGlisteringMelonSlice;